import {
  ADD_FIELD_LIST,
  ADD_VIEW,
  CLEAR_REPORT_MODEL_DESIGNER,
  DELETE_VIEW,
  EDIT_VIEW,
  REDO_REPORT_MODEL_USER_ACTION,
  SET_DATA_MODEL,
  SET_DESIGN_PANEL_WIDTH,
  SET_IS_DESIGN_PANEL_OPENED,
  SET_IS_IMPORTED_REPORT_MODEL,
  SET_IS_NEW_REPORT_MODEL,
  SET_IS_REPORT_MODEL_EXISTS,
  SET_REPORT_MODEL,
  SET_REPORT_MODEL_RELEASE_TYPE,
  SET_REPORT_MODEL_USER_ACTION_ARRAY,
  SET_SELECTED_VIEW_ID,
  SET_VIEWS,
  UNDO_REPORT_MODEL_USER_ACTION,
  UPDATE_REPORT_MODEL_USER_ACTION_ARRAY,
} from '../actions/report-model-designer.actions';
import { MAX_USER_CHANGES } from '../constants/report-model-designer.constants';
import { updateViewsAfterDeleteView } from '../utils/report-model-designer-utils';

const reportModelDesignerReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_MODEL: {
      return {
        ...state,
        reportModel: action.payload,
      };
    }

    case SET_DATA_MODEL: {
      return {
        ...state,
        dataModel: action.payload,
      };
    }

    case ADD_FIELD_LIST: {
      const { list, entityName } = action.payload;
      return {
        ...state,
        fieldLists: {
          ...state.fieldLists,
          [entityName]: list,
        },
      };
    }

    case SET_VIEWS: {
      const views = action.payload;

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          views,
        },
      };
    }

    case ADD_VIEW: {
      const newView = action.payload;
      const parentId = newView.ParentId;

      const updatedViews = state.reportModel.views.map((view) => {
        return view.Id !== parentId
          ? view
          : {
              ...view,
              HasChildren: true,
            };
      });

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          views: [...updatedViews, newView],
        },
      };
    }

    case EDIT_VIEW: {
      const { id, key, value } = action.payload;

      const updatedViews = state.reportModel.views.map((view) => {
        return view.Id !== id
          ? view
          : {
              ...view,
              [key]: value,
            };
      });

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          views: updatedViews,
        },
      };
    }

    case DELETE_VIEW: {
      const id = action.payload;

      const updatedViews = updateViewsAfterDeleteView(state.reportModel.views, id);

      return {
        ...state,
        reportModel: {
          ...state.reportModel,
          views: updatedViews,
        },
      };
    }

    case SET_SELECTED_VIEW_ID: {
      return {
        ...state,
        selectedViewId: action.payload,
      };
    }

    case SET_IS_DESIGN_PANEL_OPENED: {
      return {
        ...state,
        isDesignPanelOpened: action.payload,
      };
    }

    case SET_DESIGN_PANEL_WIDTH: {
      return {
        ...state,
        designPanelWidth: action.payload,
      };
    }

    case SET_IS_NEW_REPORT_MODEL: {
      return {
        ...state,
        isNewReportModel: action.payload,
      };
    }

    case SET_IS_IMPORTED_REPORT_MODEL: {
      return {
        ...state,
        isImportedReportModel: action.payload,
      };
    }

    case SET_IS_REPORT_MODEL_EXISTS: {
      return {
        ...state,
        isReportModelExists: action.payload,
      };
    }

    case CLEAR_REPORT_MODEL_DESIGNER: {
      return {};
    }

    case SET_REPORT_MODEL_USER_ACTION_ARRAY: {
      const { actions } = action.payload;

      return {
        ...state,
        userActions: {
          actions,
          actionPointer: 0,
        },
      };
    }

    case UPDATE_REPORT_MODEL_USER_ACTION_ARRAY: {
      const { actionType } = action.payload;

      let userActions = state?.userActions?.actions ?? [];
      const actionPointer = state?.userActions?.actionPointer ?? 0;
      const views = state?.reportModel?.views;

      if (actionPointer !== 0) {
        userActions = userActions.slice(actionPointer);
      }

      if (userActions.length - 1 === MAX_USER_CHANGES) {
        userActions.pop();
      }

      userActions.unshift({ actionType, views });

      return {
        ...state,
        userActions: {
          actions: [...userActions],
          actionPointer: 0,
        },
      };
    }

    case SET_REPORT_MODEL_RELEASE_TYPE: {
      return {
        ...state,
        releaseType: action.payload,
      };
    }

    case UNDO_REPORT_MODEL_USER_ACTION: {
      return {
        ...state,
        userActions: {
          ...state.userActions,
          actionPointer: state.userActions.actionPointer + 1,
        },
      };
    }

    case REDO_REPORT_MODEL_USER_ACTION: {
      return {
        ...state,
        userActions: {
          ...state.userActions,
          actionPointer: state.userActions.actionPointer - 1,
        },
      };
    }

    default:
      return state;
  }
};

export default reportModelDesignerReducer;
